export const GENERAL_BODY_MEETING = {
  title: "OFUESI General Body Meeting",
  dateTime: "2026-10-24T10:30:00-04:00",
  dateLabel: "Saturday, October 24, 2026",
  timeLabel: "10:30 AM Eastern (9:30 AM Central)",
  zoomUrl: "https://ofuesi.zoom.us/j/88520287320?pwd=hqYhcMU9SN89y7iMOQjJbdeC10LNbT.1",
  flyerImageUrl: "/meetings/general-body-meeting-oct-24-2026.png",
  flyerPdfUrl: "/meetings/general-body-meeting-oct-24-2026.pdf",
  flyerAlt:
    "Flyer for the OFUESI General Body Meeting (virtual), themed “God's heart for the nations” (Gen 12:3 / Colossians 1:20), with speaker Bro. Valentine Davidar on October 24, 2026 at 10:30 AM Eastern, online via Zoom, Meeting ID 885 2028 7320, passcode 457828.",
  theme: "God's heart for the nations",
  speaker: "Bro. Valentine Davidar",
} as const;

// Keep joining available through the meeting day in Eastern time.
// The meeting's end time has not been announced.
export const isGeneralBodyMeetingUpcoming = (now = new Date()) =>
  now.getTime() < Date.parse("2026-10-25T00:00:00-04:00");
